import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import FormGroup from '@material-ui/core/FormGroup'
import FormLabel from '@material-ui/core/FormLabel'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp'

// Read-only fallback for energy products that have no dedicated details
// component. Renders the entire quote object (whatever its structure) so the
// product specific payload is always visible on the front end.

// Preferred display labels for known keys; anything else is auto-formatted.
const LABEL_OVERRIDES = {
    chargerType: 'Charger Type',
    installLocation: 'Install Location',
    hasParking: 'Off-Street Parking',
    parkingType: 'Parking Type',
    houseBuilt: 'House Built',
    hasElectricCar: 'Electric Car',
    hasGrantInterest: 'Interested in Grants',
    insulationArea: 'Insulation Area',
    atticArea: 'Attic Area',
    wallArea: 'Wall Area',
    atticConverted: 'Attic Converted',
    planToConvertAttic: 'Plan to Convert Attic',
    grantInterest: 'Interested in Grants'
}

function formatLabel(key) {
    if (!key) return ''
    if (LABEL_OVERRIDES[key]) return LABEL_OVERRIDES[key]
    // insert spaces before capitals / digit groups, then title-case words
    const spaced = String(key)
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/[_-]+/g, ' ')
        .trim()
    return spaced
        .split(/\s+/)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ')
}

function formatValue(value) {
    if (value === null || value === undefined || value === '') return '-'
    if (typeof value === 'boolean') return value ? 'Yes' : 'No'
    if (Array.isArray(value)) {
        return value.length ? value.map((v) => formatValue(v)).join(', ') : '-'
    }
    if (typeof value === 'object') return JSON.stringify(value, null, 2)
    return String(value)
}

function GenericQuoteDetails(props) {
    const quote = props.lead.quote || {}
    const [showContent, setShowContent] = useState(
        props.showQuoteContent !== undefined ? props.showQuoteContent : true
    )

    const entries = Object.keys(quote)

    return (
        <Card>
            <CardHeader
                subheader={
                    <Grid
                        container
                        component={Box}
                        alignItems='center'
                        justifyContent='space-between'
                    >
                        <Grid item xs='auto'>
                            <Box
                                component={Typography}
                                variant='h3'
                                marginBottom='0!important'
                            >
                                Product Details
                            </Box>
                        </Grid>
                        <Grid item xs='auto'>
                            <Box>
                                {showContent ? (
                                    <KeyboardArrowUp />
                                ) : (
                                    <KeyboardArrowDown />
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                }
                onClick={() => setShowContent(!showContent)}
                style={{cursor: 'pointer'}}
            >
            </CardHeader>

            {showContent &&
                <CardContent>
                    {entries.length === 0 ? (
                        <Box>No product details available.</Box>
                    ) : (
                        <Grid container spacing={2}>
                            {entries.map((key) => {
                                const value = quote[key]
                                const isObject = value && typeof value === 'object'
                                return (
                                    <Grid item xs={12} lg={6} key={key}>
                                        <FormGroup>
                                            <FormLabel>{formatLabel(key)}</FormLabel>
                                            <Box
                                                component={isObject ? 'pre' : 'div'}
                                                style={isObject ? {
                                                    whiteSpace: 'pre-wrap',
                                                    margin: 0,
                                                    fontFamily: 'inherit'
                                                } : undefined}
                                            >
                                                {formatValue(value)}
                                            </Box>
                                        </FormGroup>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    )}
                </CardContent>
            }
        </Card>
    )
}

export default GenericQuoteDetails
